import revealOnScroll from "../utils/revealOnScroll"

class CategoryArchive {
	constructor(selector = ".category-archive .blog-card") {
		this.cards = Array.from(document.querySelectorAll(selector))

		this.init()
	}

	init() {
		if (!this.cards.length) {
			return
		}

		revealOnScroll(this.cards, {
			visibleClass: "is-visible",
			stagger: 80,
			observerOptions: { threshold: 0.12 }
		})
	}
}

export default CategoryArchive
